export default __webpack_public_path__ + "static/media/File No. 33.39224f73.pdf";